import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

//Local modules
import { RegisterationModule } from './authentication/registration/registeration.module';
import { LoginModule } from './authentication/login/login.module';
import { CommonComponentModule } from './common/common-component.module';

//Query file
import { ScheduleQueryService } from './queryFiles/index';

const routes = [
    {
        path: 'e-commerce',
        loadChildren: './e-commerce/e-commerce.module#FuseEcommerceModule'
    },
    {
        path: 'calendar',
        loadChildren: './calendar/calendar.module#CalendarScheduleModule'
    },
    {
        path: 'users',
        loadChildren: './contacts/contacts.module#UsersContactModule'
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        //Local modules
        RegisterationModule,
        LoginModule,
        CommonComponentModule
    ],
    declarations: [
    ],
    providers: [
        ScheduleQueryService
    ]
})
export class FuseAppsModule {
}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/apps.module.ts